import { render, staticRenderFns } from "./TabDashboard.vue?vue&type=template&id=5a268aea"
import script from "./TabDashboard.vue?vue&type=script&lang=js"
export * from "./TabDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports